// Listens for currency change events and updates the current currency and money values on the page.

export const CurrencyUpdaterConfig = {
    changedEventName: 'StoneArrow:Currency::Changed',
}

export class CurrencyUpdater {

    constructor(props = {}) {

        /* Saving the original price (from the server) into the money element's data attributes */
        document.querySelectorAll('span.money').forEach(function (element){
            var originalPrice = element.innerText;
            var dataSetKey = 'data-currency-{{ shop.currency }}';
            element.setAttribute(dataSetKey, originalPrice);
        });

        window.addEventListener(CurrencyUpdaterConfig.changedEventName, this.handleChange.bind(this));
    }

    handleChange(event) {
        const newCurrency = event.detail?.currency;
        const currencyObj = getGlobalCurrencyObj();
        if (currencyObj) currencyObj.convertAll(getCurrentCurrency(), newCurrency);
    }
}

function getGlobalCurrencyObj() {
    return window.Currency;
}

function getCurrentCurrency() {
    return getGlobalCurrencyObj()?.currentCurrency;
}